import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import logoMural from 'assets/img/logo_mural.png'

// reactstrap components
import { Collapse, NavbarBrand, Navbar, NavItem, NavLink, Nav, Container } from 'reactstrap'
import PanelContext from 'contexts/Panel'

function ExamplesNavbar() {
  const { year, semester, setYear, setSemester, years } = useContext(PanelContext)

  const handleYearChange = ({ target: { value } }) => {
    const [ year, semester ] = value.split('.')
    setYear(parseInt(year))
    setSemester(parseInt(semester))
  }

  return (
    <Navbar
      className="fixed-top"
      style={{ backgroundColor: '#E94B4A' }}
      color-on-scroll="300"
      color="#E94B4A"
      expand="lg"
    >
      <Container>
        <div className="navbar-translate">
          <NavbarBrand
            data-placement="bottom"
            to="/mural-aprovados-sisu"
            title="Mural de Aprovações SiSU Evolucional"
            tag={Link}
          >
            <img
              src={logoMural}
              alt="Mural de Aprovados SiSU Evolucional"
              style={{ width: 240, position: 'absolute', marginTop: -20 }}
              className="logotipo"
            />
          </NavbarBrand>
        </div>

        <Collapse className="justify-content-end " navbar>
          <select id="select-year" className="form-select" aria-label="Selecione o ano" onChange={handleYearChange} defaultValue={`${year}.${semester}`}>
            {years.map(item => (
              <option key={item.label} value={item.value}>{item.label}</option>
            ))}
          </select>

          <Nav navbar>
            <NavItem>
              <NavLink
                to="/meu-perfil"
                tag={Link}
                style={{
                  textTransform: 'none',
                  letterSpacing: 3,
                  fontSize: 12,
                  fontWeight: 400,
                }}
              >
                <i className="nc-icon nc-circle-10" /> Meu Perfil
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href="/sair"
                style={{
                  textTransform: 'none',
                  letterSpacing: 3,
                  fontSize: 12,
                  fontWeight: 400,
                }}
              >
                <i className="nc-icon nc-simple-remove" /> Sair
              </NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  )
}

export default ExamplesNavbar
